import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";

export class containerLogDto{
    containerLogId?:number;
    containerStatus:ContainerStatusEnum;
    containerId:number;
    createdUser:string;
    updatedUser?:string;

    constructor(containerStatus:ContainerStatusEnum, containerId:number, createdUser:string, updatedUser?:string, containerLogId?:number){
        this.containerLogId = containerLogId;
        this.containerStatus = containerStatus;
        this.containerId = containerId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
    }
}